<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form
        :model="formList"
        class="details-line-height"
        style="padding:20px 30px 0 30px"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="付款编号：">{{
              formList.payNumber | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款类型：">{{
              payTypes(formList.payType) | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="formList.suId"
              label="供应商名称："
              style="color:#276CFF"
            >
              <span v-cust @click="goSupperDetail(formList.suId)">{{
                formList.suName
              }}</span>
            </el-form-item>
            <el-form-item v-else label="客户名称：" style="color:#276CFF">
              <span v-cust @click="goCustomerDetail(formList.cid)">{{
                formList.suName
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请人：">{{
              formList.createUser | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属部门：">{{
              formList.orgName | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{
              formatData(formList.createDate)
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：">{{
              formList.mark | isNoData
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>账户信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
        :model="formList"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="账户名称：">{{
              formList.receiptName | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行账号：">{{
              formList.receiptBankNumber | isNoData
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">{{
              formList.receiptOpenBank | isNoData
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行行号：">{{
              formList.receiptOpenNumber | isNoData
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>付款信息</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0px 30px;overflow: hidden"
        :model="formList"
      >
        <el-row
          :gutter="24"
          style="background-color: #F5F7FA;padding-top: 20px;margin:0 0 20px 0;"
        >
          <el-col :span="8" style="padding: 0 0 0 10px !important;">
            <el-form-item label="申请付款总额：" style="color:#D35E5E">{{
              formList.amount | toFixed
            }}</el-form-item>
          </el-col>
          <el-col :span="8" style="padding: 0;">
            <el-form-item label="已支付金额：" style="color:#D35E5E">{{
              formList.useMoney | toFixed
            }}</el-form-item>
          </el-col>
          <el-col :span="8" style="padding: 0;">
            <el-form-item label="待支付金额：" style="color:#D35E5E">{{
              formList.notMoney | toFixed
            }}</el-form-item>
          </el-col>
        </el-row>
        <div
          v-if="
            financePayRequestSourceBillVoList[0] &&
              financePayRequestSourceBillVoList[0].pbType === 1
          "
        >
          <div
            v-for="(item, index) in financePayRequestSourceBillVoList"
            :key="index"
            style="margin-bottom: 10px;padding:20px 10px 0 10px;"
            :style="{
              backgroundColor: item.state === 2 ? 'rgba(211, 94, 94, 0.08)' : ''
            }"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="付款方式：">{{
                  payMethod(item.pbType) | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8" style="padding:0;">
                <el-form-item
                  label="付款金额："
                  style="color:rgb(211, 94, 94)"
                  >{{ item.amount | toFixed }}</el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="付款账户：">{{
                  item.billNumber | isNoData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="付款状态：">
                  <span style="color:#D35E5E">{{ state(item.state) }}</span>
                </el-form-item>
              </el-col>
              <!--               v-if="item.state === 2"-->
              <el-col :span="8">
                <el-form-item label="处理人：">{{
                  item.processUser | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="处理时间：">{{
                  item.processDate | formatData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注：">{{
                  item.exPlain || item.mark | isNoData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="
                item.state === 1 && item.financePayRequestAttachmentList.length
              "
            >
              <el-col>
                <el-form-item label="付款凭证:">
                  <div style="margin:-6px 0px;">
                    <el-button style="margin-left: 10px;" type="text"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      @click="
                        downLoadFile(item.financePayRequestAttachmentList)
                      "
                      >下载</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          v-else-if="
            (financePayRequestSourceBillVoList[0] &&
              financePayRequestSourceBillVoList[0].pbType) === 2
          "
        >
          <!--            v-show="payTypes(formList.payType) !== '客户提现'"-->

          <div
            v-for="(item, index) in financePayRequestSourceBillVoList"
            :key="index"
            style="margin-bottom: 10px;padding:20px 10px 0 10px;"
            :style="{
              backgroundColor: item.state === 2 ? 'rgba(211, 94, 94, 0.08)' : ''
            }"
          >
            <el-row :gutter="24" style="margin:0;">
              <el-col :span="8" style="padding: 0;">
                <el-form-item label="付款方式：">{{
                  payMethod(item.pbType) | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8" style="padding: 0;">
                <el-form-item
                  label="付款金额："
                  style="color:rgb(211, 94, 94)"
                  >{{ item.amount | toFixed }}</el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="票据号码：">{{
                  item.billNumber | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出票单位：">{{
                  item.billCompany | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出票行：">{{
                  item.billBank | isNoData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="出票日期：">
                  <span>{{ item.billDate | dateFilterD }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="到期日期：">{{
                  item.billEnddate | dateFilterD
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="付款状态：">
                  <span style="color:#D35E5E">{{ state(item.state) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="item.state === 2">
                <el-form-item label="处理人：">{{
                  item.processUser | isNoData
                }}</el-form-item>
              </el-col>
              <el-col :span="8" v-if="item.state === 2">
                <el-form-item label="处理时间：">{{
                  item.processDate | formatData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注：">{{
                  item.exPlain || item.mark | isNoData
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="
                item.state === 1 && item.financePayRequestAttachmentList.length
              "
            >
              <el-col>
                <el-form-item label="付款凭证:">
                  <div style="margin:-6px 0px;">
                    <el-button style="margin-left: 10px;" type="text"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      @click="
                        downLoadFile(item.financePayRequestAttachmentList)
                      "
                      >下载</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <div
      class="item-box-content"
      v-if="$route.query.again === 1 || $route.query.again === '1'"
    >
      <div class="title-font-style">
        <span>审批</span>
      </div>
      <el-form
        class="details-line-height"
        style="padding:20px 30px 0 30px"
        :model="formList"
      >
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item prop="state" label="审核结果：">
              <el-radio v-model="redio" label="2">{{
                formList.payMethod === 1 ? '修改付款账户' : '修改承兑汇票'
              }}</el-radio>
              <el-radio
                v-model="redio"
                :disabled="
                  !financePayRequestSourceBillVoList.every(
                    item => item.state === 2
                  )
                "
                label="3"
                >退回修改收款账号</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        ref="numberValidateForm"
        class="details-line-height"
        style="padding:0px 30px 0 30px"
        :model="formList"
        v-show="redio === '3'"
      >
        <el-form-item
          :prop="formList.mark"
          style="margin-left:15px"
          label="备注："
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <el-input
            v-model="textarea"
            maxlength="255"
            style="width:94%"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 银行转账的显示与隐藏 -->
      <div v-if="formList.payMethod === 1 && redio !== ''">
        <el-form
          class="details-line-height"
          style="padding:0px 30px 0 30px"
          :model="{ formBankList }"
          v-show="redio === '2'"
        >
          <el-form-item label="付款方式：">
            <span style="font-weight: 500">{{
              payMethod(formList.payMethod)
            }}</span>
            <el-button
              type="text"
              @click="addbankoder"
              style="margin-top:-10px;font-size: 14px;margin-left: 20px;font-weight: normal"
              >+添加付款账户</el-button
            >
          </el-form-item>
          <el-form-item
            label="付款账户："
            class="listspan"
            v-for="(item, index) in bankListData"
            :key="index"
          >
            <div style="margin-bottom: 15px;">
              <div style="position:relative;">
                <span>{{ item.bankobj.bankUserName }}</span>
                <span>
                  <el-select
                    v-model="item.bankobj"
                    @change="selectbank"
                    placeholder="请选择"
                    value-key="id"
                  >
                    <el-option
                      v-for="item in formBankList"
                      :key="item.id"
                      :label="item.bankOpenName"
                      :value="item"
                    ></el-option>
                  </el-select>
                </span>
                <span>
                  <el-input disabled v-model="item.bankobj.bankCode"></el-input>
                </span>
                <span
                  style="float:right;display: flex;align-items: center;margin-right: 0;"
                >
                  <span style="margin:0;">付款金额：</span>
                  <el-input
                    type="number"
                    v-model="item.amount"
                    style="flex: 1;"
                    :disabled="!item.bankobj.bankCode"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                </span>
                <el-link
                  style="position:absolute;top:0;right: -40px;"
                  type="danger"
                  v-if="index !== 0"
                  @click="delBankList(index)"
                  :underline="false"
                  >删除</el-link
                >
              </div>
              <div style="margin-top: 20px;display: flex;">
                <span style="text-align: right;width: 70px;margin:0;"
                  >备注：</span
                >
                <el-input
                  v-model="item.mark"
                  maxlength="255"
                  type="textarea"
                  :disabled="!item.bankobj.bankCode"
                  :rows="3"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 承兑汇票的显示与隐藏 -->
      <!-- v-if="payMethod===1" -->
      <div v-else-if="formList.payMethod === 2 && redio !== ''">
        <div v-show="redio === '2'">
          <el-form
            class="details-line-height"
            style="padding:0px 30px 0 30px"
            :model="moneyOrder"
          >
            <!-- v-show="addmoery" -->
            <el-form-item style="margin-bottom: 5px;" label="付款方式：">
              {{ payMethod(payName) }}
              <el-button
                type="text"
                @click="addmonery"
                style="margin-top:-10px;font-size: 14px;margin-left: 20px;"
                >+添加承兑汇票</el-button
              >
            </el-form-item>
          </el-form>
          <div
            style="padding:0 60px 0 30px;line-height: 30px;position: relative;"
            :key="index"
            v-for="(item, index) in billListData"
          >
            <div style="display: flex">
              <div>汇票信息：</div>
              <div style="flex: 1;">
                <el-row style="padding-bottom: 10px;">
                  <el-col :span="24">
                    票据号码：{{ item.billNumber }}
                    <el-button type="text" @click="updateBillData(index)"
                      >更改</el-button
                    >
                  </el-col>
                  <el-col :span="8"
                    >票据金额：{{ item.billMoney | toFixed }}</el-col
                  >
                  <el-col :span="8">出票单位：{{ item.billCompany }}</el-col>
                  <el-col :span="8">出票行：{{ item.billBank }}</el-col>
                  <el-col :span="8"
                    >出票日期：{{ item.billDate | dateFilterD }}</el-col
                  >
                  <el-col :span="8"
                    >到期日期：{{ item.billEnddate | dateFilterD }}</el-col
                  >
                </el-row>
              </div>
            </div>
            <div style="display: flex;padding-bottom: 20px;">
              <div style="flex-basis: 65px;text-align: right">备注：</div>
              <div style="flex: 1">
                <el-input type="textarea" v-model="item.mark"></el-input>
              </div>
            </div>
            <div
              style="position:absolute;top:0;right: 30px;"
              v-show="index !== 0"
            >
              <el-button
                @click="deleteHuipiao(index)"
                type="text"
                style="color:#D35E5E !important;"
                >删除</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <el-button
        type="primary"
        letter-spacing
        style="margin-left: 30px"
        @click="submitBtn()"
        >提交</el-button
      >
    </div>
    <!-- 提交的对话框 -->
    <el-dialog
      title="提交审核结果"
      :visible.sync="markuP"
      width="480px"
      style="line-height: 24px;"
    >
      <div style="padding:0 30px;">
        <div v-if="redio === '2'">
          <div>
            核审结果:
            <span>审核通过</span>
          </div>
          <div>
            付款方案:
            <span>{{ payMethod(formList.payMethod) }}</span>
          </div>
          <div>
            付款金额：
            <span style="color:red">{{ formList.notMoney | toFixed }}</span>
          </div>
          <div>确定提交审核结果？</div>
        </div>
        <div v-else>
          <div>
            核审结果:
            <span>审核不通过</span>
          </div>
          <div>
            备注:
            <span>{{ textarea }}</span>
          </div>
          <div>确定提交审核结果？</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="markuP = false">取 消</el-button>
        <el-button type="primary" @click="surnbbtn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 对对话框 --------------------------------------------------->

    <!-- 对对话框 --------------------------------------------------->

    <el-dialog title="选择承兑票号" :visible.sync="dialogVisible" width="980px">
      <span style="width: 100%">
        <el-row :gutter="24">
          <el-col :span="8" style="padding:0 20px 20px 20px;">
            <el-select v-model="queryParams.column" placeholder="请选择">
              <el-option
                v-for="item in billList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="8" style="padding: 0 20px 20px 0;">
            <el-input
              v-model="params.value"
              placeholder="通过关键字搜索"
            ></el-input>
          </el-col>
          <el-col :span="8" style="padding: 0 20px 20px 0;">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button plain @click="resetSearch">重置</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="list"
          border
          height="450"
          highlight-current-row
          @current-change="handleCurrentChangee"
        >
          <el-table-column prop="billNumber" label="票据号码"></el-table-column>
          <el-table-column prop="billMoney" label="票据面额"></el-table-column>
          <el-table-column
            prop="billCompany"
            label="出票单位"
          ></el-table-column>
          <el-table-column prop="billBank" label="出票行"></el-table-column>
          <el-table-column prop="billDate" label="出票日期">
            <template slot-scope="scope">
              {{ scope.row.billDate | dateFilterD }}
            </template>
          </el-table-column>
          <el-table-column prop="billMoney" label="到期日期"></el-table-column>
        </el-table>

        <div class="pagination" style="padding-top: 20px;">
          <pagination
            :total="total"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </span>
      <span slot="footer" class="dialog-footer" style="margin-top: -40px">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="overEvent">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 对对话框 ----------------------------------------------------------------->

    <div class="item-box-content" v-if="formList.payType === 2">
      <div class="title-font-style">
        <span>相关信息</span>
      </div>
      <el-table
        style="margin-top:20px"
        border
        ref="tableRef"
        :data="tableList"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="合同类型" prop="contractType"></el-table-column>
        <el-table-column label="合同编号" prop="pcbNumber"></el-table-column>
        <el-table-column label="供应商名称" prop="suName"></el-table-column>
        <el-table-column label="付款类型" prop="payType"></el-table-column>
        <el-table-column label="合同金额" prop="contractMoney">
          <template v-slot="{ row }">{{
            row.contractMoney | toFixed
          }}</template>
        </el-table-column>
        <el-table-column label="抵扣金额" prop="discountTotal">
          <template v-slot="{ row }">{{
            row.discountTotal | toFixed
          }}</template>
        </el-table-column>
        <el-table-column label="应付账款" prop="accountsPayable">
          <template v-slot="{ row }">{{
            row.accountsPayable | toFixed
          }}</template>
        </el-table-column>
        <el-table-column label="已到期账款" width="100px" prop="accountsDue">
          <template v-slot="{ row }">{{ row.accountsDue | toFixed }}</template>
        </el-table-column>
        <el-table-column label="待审核付款" width="100px" prop="amounts">
          <template v-slot="{ row }">{{ row.amounts | toFixed }}</template>
        </el-table-column>
        <el-table-column label="本次付款金额" width="110px" prop="amount">
          <template v-slot="{ row }">{{ row.amount | toFixed }}</template>
        </el-table-column>
        <el-table-column label="发货状态" prop="deliverState"></el-table-column>
        <el-table-column label="收票状态" prop="invoiceState"></el-table-column>
        <el-table-column
          label="当前负责人"
          width="100px"
          prop="staffCnName"
        ></el-table-column>
        <!-- staffCnName -->
        <el-table-column label="签订时间" prop="signDate">
          <template v-slot="{ row }">{{ row.signDate | formatData }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  ByPayNumber,
  financeBankInfo,
  queryAllByState,
  updateStateByFbrIdli
} from '@/api/fiance/fianceManage'
import { formatData } from '@/util/filterCommon'
import noticeApi from '@/api/workbench/notice'
import { downLoadFile } from '@/util/tool'
import { deepClone } from '@/util'
import pagination from '@/components/pagination'

export default {
  components: {
    pagination
  },
  data() {
    return {
      formList: {},
      tableList: [],
      params: {},
      textarea: '',
      radio: '1',
      orderContractStockup: {},
      waitList: [], // 待配货清单
      orderContractStockupStorageVoList: [{}], // 仓库备货区
      orderContractStockupPurchaseVoList: [],
      activeName: '合并计划', // 采购备货区tabs选中状态
      procurementPlanList: [{}], // 采购计划
      purchasingStockAreaTable: [{}],
      redio: '1',
      isShow: false, // 回退修改收款账号文本框是否展示
      addbank: true, // 修改付款账户是否显隐
      add: false,
      addMoery: false,
      btnShow: true,
      value: '',
      show: '',
      isShowTwo: false,
      financePayRequestSourceBillVoList: [],
      formBankList: {
        bankUserName: ''
      }, // 银行转账
      bankListData: [
        {
          bankobj: {}
        }
      ],
      billListData: [],
      dialogVisible: false,
      list: [], // 票据列表
      total: 1, // 列表总数

      billList: [
        { value: 'billNumber', name: '票据号码' },
        { value: 'billCompany', name: '出票单位' },
        { value: 'billBank', name: '出票行' }
      ],
      markuP: false,
      payName: '',
      moneyOrder: {},
      currentPage: 1,
      pageSize: 30,
      updateBillIndex: '',
      billCurRow: '',
      queryParams: {} // 搜索条件
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.list = deepClone(this.list)
      }
    }
  },
  mounted() {
    this.getList()
    ByPayNumber(this.$route.query.payNumber, this.$route.query.type)
      .then(res => {
        if (res.data.code === 200) {
          const resex = res.data.obj || {}
          this.formList = resex
          this.payName = this.formList.payMethod
          this.tableList = resex.purchaseFinanceVoList || []
          this.financePayRequestSourceBillVoList =
            resex.financePayRequestSourceBillVoList
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    formatData,
    payMethod(payMethod) {
      if (payMethod === 1) {
        return '银行转账'
      } else if (payMethod === 2) {
        return '承兑汇票'
      } else if (payMethod === 3) {
        return '抵扣金额'
      }
    },
    payTypes(payType) {
      if (payType === 1) {
        return '客户提现'
      } else if (payType === 2) {
        return '采购付款'
      } else if (payType === 3) {
        return '供应商充值'
      } else if (payType === 4) {
        return '退货罚没金'
      } else if (payType === 5) {
        return '维修付款'
      } else if (payType === 6) {
        return '采购退货罚款'
      }
    },
    state(state) {
      if (state === 0) {
        return '未完成'
      } else if (state === 1) {
        return '已完成'
      } else if (state === 2) {
        return '付款失败'
      } else if (state === 3) {
        return '退回审核'
      }
      // if (state === 1) {
      //   return '审核中'
      // } else if (state === 2) {
      //   return '待处理'
      // } else if (state === 3) {
      //   return '审核不通过'
      // } else if (state === 4) {
      //   return '审核不通过（退回修改）'
      // } else if (state === 5) {
      //   return '付款成功'
      // } else if (state === 6) {
      //   return '付款失败'
      // }
    },
    // 更改
    updateBillData(index) {
      this.dialogVisible = true
      this.updateBillIndex = index
    },
    // 搜索
    onSearch() {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }

      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
      }
    },
    // 添加付款账户
    addPayment() {
      this.add = true
    },
    // 通过
    aross() {
      this.addbank = true
      this.isShowTwo = false
    },
    // 不通过
    refuse() {
      this.isShowTwo = true
      this.addbank = false
    },
    dialogVisibleL(val) {
      this.choice = val
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      queryAllByState(this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
          }
        })
        .catch(err => {
          console.log(err)
        })
      this.dialogVisible = true
    },
    // 查看
    look() {
      alert('查看')
    },
    // 下载
    down() {
      alert('狭窄')
    },
    goSupperDetail(id) {
      this.$router.push({ name: 'supplierEdit', query: { id } })
    },
    goCustomerDetail(id) {
      this.$router.push({ name: 'customer/details', query: { id } })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    downLoadFile(filelist) {
      if (filelist[0] && filelist[0].guid) {
        noticeApi
          .downloadNoticeFile({
            guid: filelist[0].guid
          })
          .then(res => {
            downLoadFile(res)
          })
      }
    },
    // 添加付款账户
    addbankoder() {
      this.bankListData.push({ bankobj: {} })
    }, // 银行卡号的复制
    selectbank(item, val) {
      this.bankNumber = val
    }, // 删除
    deletmoney() {
      this.add = false
      this.isShowTwo = false
      this.money = {}
    },
    delBankList(index) {
      this.bankListData.splice(index, 1)
    },
    // 添加承兑汇票
    addmonery() {
      this.dialogVisible = true
      this.dialogVisibleL()
    },
    // 提交
    submitBtn() {
      // 银行转账
      if (this.payName === 1) {
        // 通过
        if (this.redio === '2') {
          const { bankListData, formList } = this
          let n = 0
          bankListData.forEach(item => {
            n += Number(item.amount)
          })
          if (n !== formList.notMoney) {
            this.$message.error('设置金额总额与申请付款金额不一致')
            return
          }
          this.markuP = true
          // 不通过
        } else if (this.redio === '3') {
          if (this.textarea === '') {
            this.$message.error('备注不可为空！！')
          } else {
            this.markuP = true
          }
        }
      } else {
        // 承兑汇票
        const { billListData } = this
        if (this.redio === '3') {
          if (this.textarea === '') {
            this.$message.error('备注不可为空！！')
          } else {
            this.markuP = true
          }
        } else if (this.redio === '2') {
          if (!billListData.length) {
            this.$message.error('请选择承兑汇票！')
          } else {
            let n = 0
            billListData.forEach(item => {
              n += item.billMoney
            })
            if (n !== this.formList.amount) {
              this.$message.error('设置金额总额与申请付款金额不一致')
            } else {
              this.markuP = true
            }
          }
        }
      }
    },
    deleteHuipiao(index) {
      this.billListData.splice(index, 1)
    },
    overEvent() {
      const { billCurRow, updateBillIndex } = this
      if (
        this.billListData.find(item => item.id === billCurRow && billCurRow.id)
      ) {
        this.$message.error('该承兑票好已被选择，请勿重复选择')
        return
      }
      if (updateBillIndex === '' && billCurRow) {
        this.billListData.push(billCurRow)
      } else if (this.billListData[updateBillIndex] && billCurRow) {
        this.billListData[updateBillIndex] = billCurRow
        this.updateBillIndex = ''
      }
      this.billCurRow = ''
      this.dialogVisible = false
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    getList() {
      financeBankInfo()
        .then(res => {
          if (res.data.code === 200) {
            this.formBankList = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 弹框赋值
    handleCurrentChangee(val) {
      this.billCurRow = val
    },
    resetSearch() {
      this.queryParams.column = ''
      this.params.value = ''
      this.dialogVisibleL()
    },
    surnbbtn() {
      this.markuP = false
      const list = []
      const { bankListData, formList, billListData } = this
      if (formList.payMethod === 1) {
        // 银行转账
        bankListData.forEach(item => {
          list.push({
            amount: item.amount,
            pbType: formList.payMethod,
            payId: item.bankobj.id,
            mark: item.mark,
            state: formList.state
          })
        })
      } else {
        // 承兑汇票
        billListData.forEach(item => {
          list.push({
            amount: item.billMoney,
            pbType: formList.payMethod,
            payId: item.id,
            mark: item.mark,
            state: formList.state
          })
        })
      }
      updateStateByFbrIdli({
        financePayRequestSourceList: list,
        fprId: this.formList.id,
        mark: this.textarea,
        payType: this.formList.payType,
        state: this.redio === '2' ? 5 : 4
      })
        .then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.$router.push('/finance/financeManage/waitAuditPayApplyList')
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.pay {
  padding-top: 8px;
  font-weight: bold;
}

.look {
  color: blue;
  padding-left: 20px;
}

.paymonery {
  padding-left: 70px;
  position: relative;
  top: -20px;
}

.fine-tuning {
  margin-top: -5px;
}

.listspan {
  margin-right: 30px;
}

.listspan span {
  vertical-align: middle;
  margin-top: -8px;
  margin-right: 20px;
}
</style>
